module.exports = __webpack_public_path__ + "static/doris-5fa5a309ff1fc7b874a26b6cd110a313.jpg";